export enum AddScanToULDAction {
  ADD = 'ADD',
  REMOVED = 'REMOVED',
  DO_NOT_LOAD = 'DO_NOT_LOAD',
}

export enum DiscriminatorType {
  DOMESTIC = 'DOMESTIC',
  INTERNATIONAL = 'INTERNATIONAL',
}
